import { useEffect } from 'react';

const usePageTitle = (upcomingCount, loading) => {
  useEffect(() => {
    const updateTitle = () => {
      if (loading) {
        document.title = 'Loading... | LeanFITT™ Pro';
        return;
      }

      if (upcomingCount > 0) {
        document.title = `(${upcomingCount}) LeanFITT™ Pro`;
      } else {
        document.title = 'LeanFITT™ Pro';
      }
    };

    updateTitle();

    // Cleanup function to reset title when component unmounts
    return () => {
      document.title = 'LeanFITT™ Pro';
    };
  }, [upcomingCount, loading]);
};

export default usePageTitle;